/* ========================================
   PRODUCT CARD VARIANT IMAGE SWAPPING
   ======================================== */

document.addEventListener('DOMContentLoaded', function() {
  const variantSwatches = document.querySelectorAll('.js-variant-swatch');
  
  variantSwatches.forEach(swatch => {
    // Disable hover image when hovering over swatches
    swatch.addEventListener('mouseenter', function() {
      const productCard = this.closest('.product-card');
      if (productCard) {
        productCard.classList.add('swatch-hover-active');
      }
    });
    
    swatch.addEventListener('mouseleave', function() {
      const productCard = this.closest('.product-card');
      if (productCard) {
        productCard.classList.remove('swatch-hover-active');
      }
    });
    
    // Handle swatch click to preview variant
    swatch.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const productCard = this.closest('.product-card');
      if (!productCard) return;
      
      const variantImage = this.getAttribute('data-variant-image');
      
      // Update main product images
      const mainImage = productCard.querySelector('.product-card__image img.first-image');
      const secondImage = productCard.querySelector('.product-card__image img.second-image');
      
      if (mainImage && variantImage) {
        mainImage.src = variantImage;
        mainImage.srcset = variantImage;
      }
      
      if (secondImage && variantImage) {
        secondImage.src = variantImage;
        secondImage.srcset = variantImage;
      }
      
      // Update active state
      const allSwatches = productCard.querySelectorAll('.js-variant-swatch');
      allSwatches.forEach(s => s.classList.remove('active'));
      this.classList.add('active');
    });
  });
});